module.exports = __webpack_public_path__ + "static/media/to.89df4a46.svg";